import Button from "components/Button/Button";
import { IconWrapper } from "components/Icon/Icon";
import PreLoader from "components/PreLoader/PreLoader";
import styled from "styled-components";
import { PriceWrapper } from "styles/serviceRequestStyles";

export const Spinner = styled(PreLoader)`
  position: absolute;
  top: 100px;
`;

export const Price = styled(PriceWrapper)`
  border-bottom: none;
`;

export const SubmitButton = styled(Button)`
  margin-top: auto;
  align-self: center;
`;

export const TransferWrapper = styled.div`
  display: flex;
  gap: 8px;
  padding-top: 8px;

  & > p {
    flex-shrink: 0;
  }
`;

export const TransferCodeWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  width: 100%;
`;

interface CustomRasterIconProps {
  $isProcessed?: boolean;
}

export const CustomRasterIcon = styled(IconWrapper)<CustomRasterIconProps>`
  height: 18px;
  width: 18px;
  background-color: ${({ theme, $isProcessed }) =>
    $isProcessed === true
      ? theme.secondary
      : $isProcessed === false
        ? theme.lightgrey
        : theme.grey};
`;

interface PriceProps {
  $isHighlighted: boolean;
}

export const GroupItem = styled.span<PriceProps>`
  display: flex;
  padding: 25px 20px 25px 25px;
  color: ${({ $isHighlighted, theme }) =>
    $isHighlighted ? theme.black : theme.black50};
  width: 100%;
  justify-content: space-between;
  border-bottom: none;
  cursor: pointer;
  transition: background-color 0.2s;
  border-radius: 2px;

  &:hover {
    background-color: ${({ theme }) => theme.subtleHover};
    font-weight: 500;
  }
`;

export const GroupItemHeader = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const GroupItemCost = styled.span<PriceProps>`
  color: ${({ $isHighlighted, theme }) =>
    $isHighlighted ? theme.black : theme.black50};
`;
